<template>
    <footer id="footer" class="default-footer">
        <p class="pagetop" id="pagetop"><a href="#" v-scroll-to="'#top'">PAGE TOP<span></span></a></p>

        <div class="inner">
            <div class="area01">
                <div class="logo"><img src="../../assets/footer_logo01.png" alt=""></div>
                <div class="menu">
                    <ul>
                        <li><router-link :to="{name: 'About'}">About</router-link></li>
                        <li><router-link :to="{name: 'FullList'}">Full List</router-link></li>
                        <li><router-link :to="{name: 'PlanYourVisit'}">Itineraries</router-link></li>
                        <li><router-link :to="{name: 'LuxuryTravel'}">Luxury</router-link></li>
                        <li><router-link :to="{name: 'SpiritOfJapan7'}">Spirit of Japan</router-link></li>
                        <li><router-link :to="{name: 'DiscoverMore2'}">Discover</router-link></li>
                        <li><router-link :to="{name: 'Movies'}">Videos</router-link></li>
                        <li><router-link :to="{name: 'VRMovies'}">VR</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="area02">
                <div class="subMenu">
                    <ul>
                        <li><router-link :to="{name: 'HelpfulInfo'}">Helpful Info</router-link>
                            <ul>
                                <li><router-link :to="{name: 'HelpfulInfo'}"
                                                 v-scroll-to="{
                                                 el: '#goInfo',
                                                 offset: -200
                                                 }">General Information</router-link></li>
                                <li><router-link :to="{name: 'HelpfulInfo'}"
                                                 v-scroll-to="{
                                                 el: '#goCulture',
                                                 offset: -200
                                                 }">Going to See Cultural Properties</router-link></li>
                            </ul>
                        </li>
                        <li><router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link></li>
                        <li><router-link :to="{name: 'Copyright'}">Copyright</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="area03">Copyright © Website produced by Japan National Tourism Organization.<br>Content provided by Agency for Cultural Affairs. All Rights Reserved.</div>
            <div class="area04">
                <div class="logos">
                    <ul>
                        <li><img src="../../assets/footer_logo02.png" alt=""></li>
                        <li><a href="https://www.japan.travel/en/" target="_blank"><img src="../../assets/footer_logo03.png" alt="JNTO"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "DefaultFooter",
        methods: {
            scroll: function () {
                scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
            scrollToHash: function () {
                const hash = this.$route.hash;
                this.$scrollTo(hash, 1, { offset: -100 });
            }
        },
    }
</script>

<style src="./DefaultFooter.scss" lang="scss" scoped />
